import React from "react";

export function PageHeader({ title, subtitle, action, actions, icon: Icon, children }) {
  return (
    <div className="flex flex-wrap items-end justify-between gap-3 mb-6 border-b border-zinc-800/70 pb-5">
      <div className="flex items-start gap-3">
        {Icon && (
          <div className="mt-1 p-2 rounded-md bg-amber-500/10 border border-amber-500/30 text-amber-300">
            <Icon className="w-5 h-5" />
          </div>
        )}
        <div>
          <h1 className="text-2xl font-bold tracking-tight text-zinc-50">{title}</h1>
          {subtitle && <p className="text-sm text-zinc-400 mt-1">{subtitle}</p>}
        </div>
      </div>
      {action || actions || children}
    </div>
  );
}
